import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import { UserService } from 'src/app/_services/generatedServices';
import { StringViewModel, StripeDataViewModel } from 'src/app/_models/generatedModels';

@Component({
  selector: 'bxl-payments',
  templateUrl: 'payments.component.html',
})
export class PaymentsComponent implements OnInit, OnDestroy {
  stripeUrl = '';
  stripeDashboard = '';
  routeDataSubscription: Subscription;
  querySubscription: Subscription;
  oauth: boolean;
  oauthCode: string;
  initialized = false;
  stripeData: StripeDataViewModel;
  state: string;

  constructor(private settings: SettingsProvider, public auth: AuthenticationService, private router: Router, private userService: UserService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.stripeDashboard = 'api/users/stripeDashboard?access_token=' + this.auth.getToken();
    this.routeDataSubscription = this.route.data.subscribe((v) => {
      this.querySubscription = this.route.queryParamMap.subscribe((params) => {
        this.oauth = v.oauth;
        this.oauthCode = params.get('code');
        this.state = params.get('state');

        this.auth.fetchUserProfile().subscribe((user) => {
          this.loadPage();
        });
      });
    });
  }

  loadPage() {
    if (this.oauth) {
      this.completeOauth();
    } else {
      this.loadConnectButton();
    }
  }

  loadConnectButton() {
    let redirect_uri = this.settings.siteUrl + '/account/stripe-complete-oauth';
    this.stripeUrl = 'https://connect.stripe.com/express/oauth/authorize?redirect_uri=' + redirect_uri + '&client_id=' + this.settings.stripeClientKey + '&state=23123123123&&stripe_user[email]=' + this.auth.user.email + '&stripe_user[first_name]=' + this.auth.user.firstName + '&stripe_user[last_name]=' + this.auth.user.lastName; // + '&suggested_capabilities[]=transfers&suggested_capabilities[]=tax_reporting_us_1099_k&tos_acceptance[service_agreement]=recipient';

    this.userService.getStripeData().subscribe((data) => {
      this.stripeData = data;
      this.initialized = true;
    });
  }

  completeOauth() {
    let model = new StringViewModel();
    model.value = this.oauthCode;
    this.userService.completeStripeOauth(model).subscribe((user) => {
      this.auth.user = user;
      if (this.state && this.state.startsWith('conf:')) {
        var confId = this.state.replace('conf:', '');
        this.router.navigate(['/account/payments/expenses/', confId]);
      } else {
        this.router.navigate(['/account/payments']);
      }
    });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription.unsubscribe();
    this.querySubscription.unsubscribe();
  }
}
